import { render, staticRenderFns } from "./radish-list-match.vue?vue&type=template&id=79c85e30&"
import script from "./radish-list-match.vue?vue&type=script&lang=js&"
export * from "./radish-list-match.vue?vue&type=script&lang=js&"
import style0 from "./radish-list-match.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports